<template>
  <div>
    <div class="footer-container">
    <p class="footer-item link" v-on:click="showModal = true">Aviso Legal</p>
    <p class="footer-item">{{ `Datos actualizados al: ${creationDate}` }}</p>
    </div>
    <el-dialog title="Aviso Legal" :visible.sync="showModal" :before-close="closeModal">
      <div>
        <p>{{legalNotice}}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { legalNoticeText } from "@/componentConfig";

export default {
  name: 'PortfolioFooter',
  props: {
    creationDate: '',

  },
  data () {
    return {
      legalNotice: legalNoticeText,
      showModal: false
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    }
  }
}
</script>

<style scoped>

.footer-container {
  display: flex;
  flex-direction: row;
}

.footer-item {
  height: 60px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 20px;
}

.footer-item.link {
  text-decoration: underline;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/PortfolioFooter.vue